import React, { memo } from 'react';
import PersonWithPosition from '../../PersonWithPosition/PersonWithPosition';
import styles from '../table.module.scss';

const AuthorCell = memo(({ record, textStyle }) => {
  return (
    <div className={styles.additionalInfo}>
      <h4 className={styles.additionalInfoTitle}>Автор</h4>
      <PersonWithPosition
        person={record.createUser}
        className={styles.tdItem}
      />
    </div>
  );
});

export default AuthorCell;
